import { render, staticRenderFns } from "./UpdateProject.vue?vue&type=template&id=4b14aeda&scoped=true"
import script from "./UpdateProject.vue?vue&type=script&lang=js"
export * from "./UpdateProject.vue?vue&type=script&lang=js"
import style0 from "./UpdateProject.vue?vue&type=style&index=0&id=4b14aeda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b14aeda",
  null
  
)

export default component.exports